import { render } from "./NotificationTemplateOverview.vue?vue&type=template&id=76c83686&scoped=true&ts=true"
import script from "./NotificationTemplateOverview.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplateOverview.vue?vue&type=script&lang=ts"

import "./NotificationTemplateOverview.vue?vue&type=style&index=0&id=76c83686&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c83686"]])

export default __exports__